import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { API } from "./apiutil";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class CommentsService {
    http;
    constructor(http) {
        this.http = http;
    }
    search(ctx) {
        return this.http.get(`${environment.base}/comments/${ctx.id}`, { params: API.makeParams(ctx) });
    }
    create(relationId, comment) {
        return this.http.post(`${environment.base}/comments/${relationId}`, comment);
    }
    static ɵfac = function CommentsService_Factory(t) { return new (t || CommentsService)(i0.ɵɵinject(i1.HttpClient)); };
    static ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CommentsService, factory: CommentsService.ɵfac });
}
